import { PluginManifest } from '@embedpdf/core';
import { UIPluginConfig } from './types';

export const UI_PLUGIN_ID = 'ui';

export const manifest: PluginManifest<UIPluginConfig> = {
  id: UI_PLUGIN_ID,
  name: 'UI Plugin',
  version: '1.0.0',
  provides: ['ui'],
  requires: [],
  optional: ['i18n'],
  defaultConfig: {
    schema: {
      id: 'empty',
      version: '1.0.0',
      toolbars: {},
      menus: {},
      sidebars: {},
      modals: {},
      selectionMenus: {},
    },
  },
};
